import { takeLatest, call, put } from 'redux-saga/effects';
import {
    GET_EMPLOYEE_REQUEST,
    SET_EMPLOYEE_REQUEST,
    CREATE_EMPLOYEE_REQUEST,
    UPDATE_EMPLOYEE_REQUEST,
    ADD_EMPLOYEE_FILES_REQUEST,
    REMOVE_EMPLOYEE_FILE_REQUEST
} from "../constants/employeeActionTypes";
import {
    getEmployeeSuccess,
    getEmployeeFailure,
    setEmployeeSuccess,
    setEmployeeFailure,
    createEmployeeSuccess,
    createEmployeeFailure,
    updateEmployeeSuccess,
    updateEmployeeFailure,
    addEmployeeFilesSuccess,
    addEmployeeFilesFailure,
    removeEmployeeFileSuccess,
    removeEmployeeFileFailure
} from "../actions/employeeActions";
import { handleApiRequest } from '../utils/sagaUtils';
import {apiCall} from "../utils/api";
import {toast} from "react-toastify";
import {addContractSuccess} from "../actions/contractActions";

const getEmployee = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employee-api/getEmployee`, 'POST', data);
const setEmployee = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employee-api/setEmployee`, 'POST', data);
const createEmployee = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employee-api/createEmployee`, 'POST', data);
const updateEmployee = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employee-api/updateEmployee`, 'POST', data);
const addEmployeeFiles = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employee-api/updateEmployeeFiles`, 'POST', data);
const removeEmployeeFile = (data) => apiCall(`${process.env.REACT_APP_API_URL}/employee-api/removeEmployeeFile`, 'POST', data);

function* getEmployeeSaga(action) {
    yield* handleApiRequest(action, getEmployee, getEmployeeSuccess, getEmployeeFailure);
}

function* setEmployeeSaga(action) {
    yield* handleApiRequest(action, setEmployee, setEmployeeSuccess, setEmployeeFailure);
}

function* createEmployeeSaga(action) {
    const response = yield call(createEmployee, action.payload);
    if (response.error) {
        toast(response.error);
        yield put(createEmployeeFailure(response.error));
    } else {
        toast(response.msg);
        yield put(createEmployeeSuccess(response.contractEntry.employee));
        yield put(addContractSuccess(response.contractEntry));
    }
}

function* updateEmployeeSaga(action) {
    yield* handleApiRequest(action, updateEmployee, updateEmployeeSuccess, updateEmployeeFailure);
}

function* addEmployeeFilesSaga(action) {
    yield* handleApiRequest(action, addEmployeeFiles, addEmployeeFilesSuccess, addEmployeeFilesFailure);
}

function* removeEmployeeFileSaga(action) {
    yield* handleApiRequest(action, removeEmployeeFile, removeEmployeeFileSuccess, removeEmployeeFileFailure);
}

export default function* watchEmployeeSagas() {
    yield takeLatest(GET_EMPLOYEE_REQUEST, getEmployeeSaga);
    yield takeLatest(SET_EMPLOYEE_REQUEST, setEmployeeSaga);
    yield takeLatest(CREATE_EMPLOYEE_REQUEST, createEmployeeSaga);
    yield takeLatest(UPDATE_EMPLOYEE_REQUEST, updateEmployeeSaga);
    yield takeLatest(ADD_EMPLOYEE_FILES_REQUEST, addEmployeeFilesSaga);
    yield takeLatest(REMOVE_EMPLOYEE_FILE_REQUEST, removeEmployeeFileSaga);
}